<form [formGroup]="form" (ngSubmit)="save()">
    <div  class="card-inline">
        <div class="card-inline">
            <h1 mat-dialog-title *ngIf="!connectionError && !connected">Escaner: {{scannerName}} (escaner ocupado)</h1>
            <h1 mat-dialog-title *ngIf="!connectionError && connected">Escaner: {{scannerName}} (conectado)</h1>
            <h1 mat-dialog-title *ngIf="connectionError">Escaner: {{scannerName}} (error en la conexión)</h1>
        </div>
        <div class="card-inline">
            <button type="button" (click)="selectScanner()" mat-mini-fab>
              <mat-icon>add</mat-icon>
          </button>
        </div>
    </div>

    <div style="text-align: center;width: 100%;">
        <button *ngIf="!scanning" type="button" (click)="sendScann()" mat-fab>
                  <mat-icon>scanner</mat-icon>
      </button>
        <mat-spinner *ngIf="scanning" [diameter]="20"></mat-spinner>
    </div>
    <div class="scann-scroll" formArrayName="MedicalsOrderScann">
        <mat-card class="preview-image-scann" *ngFor="let medicalOrderScann of medicalsOrderScann.controls; let index = index" [formGroupName]="index">
            <img class="preview-image" mat-card-image *ngIf="getImage(index)" [src]="getSafeUrl(index)">
            <mat-spinner *ngIf="!getSafeUrl(index)" [diameter]="100"></mat-spinner>
            <mat-card-actions>
                <mat-form-field class="full-width">
                    <mat-select formControlName="MedicalOrderScannTypeId" placeholder="Tipo" required>
                        <mat-option *ngFor="let medicalOrderScannType of medicalOrderScannTypes" [value]="medicalOrderScannType.Id">
                            {{medicalOrderScannType.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <button type="button" (click)="remove(index)" mat-button>
      <mat-icon>delete_forever</mat-icon>
    </button>
            </mat-card-actions>
        </mat-card>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <mat-spinner *ngIf="loadingAction" [diameter]="100"></mat-spinner>
            <button mat-button *ngIf="!loadingAction" type="submit">Guardar</button>
            <button mat-button *ngIf="!loadingAction" type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>
